import { useEffect, useRef, useState } from "react";
import width from "../../SimpleForm/BaseInputs/helper";
import BaseInput from "../../SimpleForm/BaseInputs/BaseInput";

export const LinkageTextInput = ({ ...props }) => {
  const {
    schemaProps: {
      linkages: {
        toFieldArray,
        toLinkageIdFieldName,
        linkageId,
        fieldToModify,
      },
    },
    formValues,
  } = props;
  const isUnmounting = useRef(false);
  let fieldValue = props?.input?.value;
  const [originalValue, setOriginalValue] = useState("");

  // Mark the component as unmounting for cleanup below
  useEffect(() => {
    return () => {
      isUnmounting.current = true;
    };
  }, []);

  useEffect(() => {
    if (originalValue === "") {
      setOriginalValue(fieldValue);
    }
    return () => {
      // When component is unmounting without a chance to onBlur, ex: changing sections, still execute
      if (fieldValue !== originalValue && isUnmounting.current) {
        handleLinkageUpdates(fieldValue);
      }
    };
  }, [fieldValue]);

  const handleLinkageUpdates = () => {
    if (fieldValue !== originalValue) {
      setOriginalValue(fieldValue);

      const fieldArrayToModify = formValues[toFieldArray];
      fieldArrayToModify?.forEach((row) => {
        if (row?.[toLinkageIdFieldName] === linkageId) {
          row[fieldToModify] = fieldValue;
        }
      });
    }
  };

  return (
    <BaseInput
      {...props}
      input={{
        ...props?.input,
        onBlur: () => {
          props?.input?.onBlur();
          handleLinkageUpdates();
        },
      }}
    />
  );
};
